module.exports = __webpack_public_path__ + "media/images/btn-play-66730a511218cbc40723582d83e4e462.svg";